import React from "react";
import "./index.scss";
import { routesObj } from "../../routes/routes";
import { useMediaQuery } from "react-responsive";
import logo from "../../assets/images/logo/logo.svg";
import cart from "../../assets/images/shopping_cart/shopping_cart.svg";
import account from "../../assets/images/account_circle/account_circle.svg";
import { Badge } from "antd";
import { useAppSelector } from "../../hooks";

const Header = () => {
  const cartItems = useAppSelector((state) => state.cart);
  const handleClickLogo = () => {
    window.location.href = "/";
  };
  const handleLogin = () => {
    window.location.href = `${routesObj.myPage.path}`;
  };
  const handleCart = () => {
    const items = JSON.parse(localStorage.getItem('items'));
    if (items !== null && items.cartTotalItem !== undefined && items.cartTotalItem !== 0) {
      window.location.href = "/cart/list_orders";
    } else {
      window.location.href = "/cart/empty_cart";
    }
  };
  const count = cartItems.cartTotalItem;

  const nonOnlyMobile = useMediaQuery({
    query: "(min-width: 390px)",
  });
  const layoutStyle = () => {
    let classCustom = "";
    if (nonOnlyMobile) {
      classCustom = "header-default";
    } else {
      classCustom = "header-default header-min";
    }
    return classCustom;
  };
  return (
    <div className={layoutStyle()}>
      <div className="header-layout" style={{ height: "64px" }}>
        <h1 className="header-left" style={{ marginTop: "0.67em", marginBottom: "0.67em" }}>
          <div className="logo" onClick={handleClickLogo}>
            <img src={logo} alt="logo" loading="lazy" decoding="async" />
          </div>
        </h1>
        <div className="header-right" style={{ width: "20%" }}>
          <div className="cart" onClick={handleCart}>
            {count ? (
              <Badge count={count} overflowCount={999}>
                <img
                  src={cart}
                  alt="cart"
                  style={{ width: "80%", position: "relative" }}
                  loading="lazy"
                  decoding="async"
                />
              </Badge>
            ) : (
              <img
                src={cart}
                alt="cart"
                style={{ width: "80%", position: "relative" }}
                loading="lazy"
                decoding="async"
              />
            )}
          </div>
          <div className="account" onClick={handleLogin}>
            <img
              src={account}
              alt="user"
              style={{ width: "80%" }}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
